import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class PerfInterceptor implements HttpInterceptor {
  private readonly ingestUrl = environment.debugIngestUrl;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startedAt = Date.now();
    return (next.handle(req) as any).pipe(
      tap({
        next: (event) => {
          if (!(event instanceof HttpResponse)) return;
          if (!environment.performance?.enableDebugIngest) return;
          const durationMs = Date.now() - startedAt;
          const contentLength = event.headers?.get('content-length');
          const serverDurationMs = event.headers?.get('x-server-duration-ms');
          const gatewayDurationMs = event.headers?.get('x-gateway-duration-ms');
          const body = event.body;
          const bodyType = Array.isArray(body) ? 'array' : typeof body;
          const bodyCount = Array.isArray(body) ? body.length : undefined;
          const payload = { location: 'perf.interceptor.ts', message: 'http_response', data: { url: req.urlWithParams, method: req.method, status: event.status, durationMs, contentLength, serverDurationMs, gatewayDurationMs, bodyType, bodyCount }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'perf-1', hypothesisId: 'H1' };
          fetch(this.ingestUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).catch(() => {});
        },
        error: (error: HttpErrorResponse) => {
          if (!environment.performance?.enableDebugIngest) return;
          const durationMs = Date.now() - startedAt;
          const payload = { location: 'perf.interceptor.ts', message: 'http_error', data: { url: req.urlWithParams, method: req.method, status: error.status, statusText: error.statusText, message: error.message, name: (error as any)?.name, errorType: (error as any)?.error?.type, durationMs }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'perf-1', hypothesisId: 'H1' };
          fetch(this.ingestUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).catch(() => {});
        }
      })
    );
  }
}
